// extracted by mini-css-extract-plugin
export default {"loader":"Preloader_loader__hoSdr","spin":"Preloader_spin__nn+kn"};